import React from 'react';

function NumpadKeyboardButton({ children, handleClick }) {
  return (
    <button className='numpad-btn-item main-item' onClick={handleClick}>
      {children}
    </button>
  );
}

export default NumpadKeyboardButton;
